import * as core from '../../../../../../../core'

export const RESOURCE = {
  payload: {
    alias: 'sr:subrecipients',
    content: {
      root: {
        elements: [
          {
            height: 800,
            content: {
              widget: {
                widget: {
                  alias: 'sr.subrecipients.widgets.subrecipients-table',
                },
              },
            },
          },
        ],
      },
    },
    description: 'Subrecipients',
    name: 'Subrecipients',
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicPage>
